module.exports = __webpack_public_path__ + "static/img/14.dbcadf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/14.jpg
// module id = JqjM
// module chunks = 0